<template>
  <card class="card-stats rounded" :class="'severity-'+appointment.severity">
    <div class="statistics statistics-horizontal">
      <div class="info info-horizontal">
        <div class="row appointment-id justify-content-between pr-4 pl-4 pb-2">
          <div class="" style="font-size: small; font-weight: 600;" v-if="appointment.referenceId">
            <span style="margin-right: 0.5em">
              <i class="fas fa-hashtag"></i>
            </span>
            <span>{{ appointment.referenceId }}</span>
          </div>

          <div style="font-size: 1.5em;line-height: 1;">
            <div v-if="appointment.patient.gender == 'male'">
              <span>
                <i class="fa fa-mars"></i>
              </span>
            </div>
            <div v-if="appointment.patient.gender == 'female'">
              <span>
                <i class="fa fa-venus"></i>
              </span>
            </div>
            <div v-if="appointment.patient.gender == 'others'">
              <span>
                <i class="fa fa-transgender-alt"></i>
              </span>
            </div>
          </div>

        </div>
        <div class="row visit-details details">
          <div class="col-3 col-md-3 pr-0">
            <div class="row">
              <div class="col-12 text-center">
                <img :src="avatarImage" class="picture-src" style="
                    width: 100px;
                    border-radius: 50%;
                    outline-color: transparent;
                  " />
                <br />
              </div>
            </div>
          </div>
          <div class="col-9 col-md-9 right">
            <slot>
              <div class="row">
                <div v-if="unreadMessagesCount > 0 && chatMode" style="position: absolute;inset-inline-end: 1em;display: flex;justify-content: center;align-items: start;">
                  <span style="color: white;position: absolute;font-size: 0.7em;margin-top: 0.4em;">
                    {{unreadMessagesCount}}
                  </span>
                  <span>
                    <i class="far fa-comment-alt" style="font-weight: 900;color: var(--color-primary);font-size: 2em;"></i>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-user"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.patient.firstName }}
                    {{ appointment.patient.lastName }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-info-circle"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.patient.patientId }}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fas fa-clipboard-check"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.latestStatus }}</span>
                </div>
              </div>
              <div class="row" v-if="appointment.patient.mobileNumber">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-mobile"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.patient.mobileNumber }}</span>
                </div>
              </div>
              <!--               <div class="row">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-question"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{ appointment.reason }}</span>
                </div>
              </div> -->
              <div class="row" v-if="appointment.appointmentType == 'Scheduled'">
                <div class="col-md-3 col-3 text-center">
                  <span>
                    <i class="fa fa-clock-o"></i>
                  </span>
                </div>
                <div class="col-md-9 col-9 pl-0">
                  <span>{{
                    getAppointmentDatetime(appointment.scheduledTimestamp.start)
                  }}</span>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="stats" slot="footer">
      <slot name="footer"></slot>
      <n-button round type="primary" size="md" :style="(appointment.severity && appointment.severity < 5)? {backgroundColor: '#fff',color: 'grey',fontWeight: 'bold'} : {fontWeight: 'bold'}" @click.native="startTriage">
        Triage
      </n-button>
    </div>

    <loading :active.sync="LOADING" :can-cancel="false" :is-full-page="true" color="#2ca8ff">
      <template v-slot:after>
        <h5 class="text-info">{{ loaderText }}</h5>
      </template>
    </loading>
  </card>
</template>

<script>
import avatarImage from "@/assets/img/proAvatar.png";
import moment from "moment-timezone";
import socket from "@/services/socket";

export default {
  name: "AppointmentDetailsCard",

  data() {
    return {
      avatarImage,
      loader: null,
      LOADING: false,
      loaderText: "",
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    chatMode() {
      if (
        this.appointment.consultationType == "telemed-direct" &&
        this.settings.directTelemedicine.consultancyParadigm == "chat"
      ) {
        return true;
      } else if (this.settings.consultancyParadigm == "chat") {
        return true;
      } else {
        return false;
      }
    },
    unreadMessagesCount() {
      if (
        this.appointment.unreadMessagesCount &&
        this.appointment.unreadMessagesCount.hasOwnProperty(this.user._id)
      ) {
        return this.appointment.unreadMessagesCount[this.user._id];
      } else {
        return 0;
      }
    },
  },

  props: ["appointment"],

  methods: {
    getAppointmentDatetime(timestamp) {
      return moment(Number(timestamp)).format("hh:mm a");
    },
    async startTriage() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      try {
        this.appointment = await this.$store.dispatch(
          "startTriaging",
          this.appointment._id
        );
        console.debug("Encounter", this.appointment);
        this.$store.commit("setState", {
          stateName: "erEncounter",
          stateValue: this.appointment,
        });
        this.$router.push({ path: "/emergencyTriaging/create" });
      } catch (e) {
        console.error("Error starting triage", e);
      }
      loader.hide();
    },
  },
};
</script>

<style scoped>
/deep/ .vld-icon {
  text-align: center;
}

.severity-1 {
  background-color: #ff3636;
  color: white;
}
.severity-2 {
  background-color: orange;
  color: white;
}
.severity-3 {
  background-color: #00b300;
  color: white;
}
.severity-4 {
  background-color: rgb(44, 168, 255);
  color: white;
}
.severity-5 {
  background-color: #e1e1e1;
}

.severe {
  /* background: linear-gradient(
    143deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 255, 255, 1) 83%
  ); */

  background-color: #ff3636;
}

.not-severe {
  /* background: linear-gradient(
    143deg,
    rgb(44, 168, 255) 0%,
    rgba(255, 255, 255, 1) 83%
  ); */

  background-color: rgb(44, 168, 255);
}
</style>
